var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpotIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 646h160v-60H240v60Zm519.882-80Q714 566 682 533.882q-32-32.117-32-78Q650 410 682.083 378q32.084-32 77.917-32 13 0 25.5 3t24.5 8V136h150v60h-90v260q0 45.833-32.118 77.917-32.117 32.083-78 32.083ZM240 526h280v-60H240v60Zm0-120h280v-60H240v60Zm0 410L80 976V236q0-24.75 17.625-42.375T140 176h480q24.75 0 42.375 17.625T680 236v59q-45 24-72.5 67T580 456q0 51 27.5 94t72.5 67v139q0 24.75-17.625 42.375T620 816H240Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotIcon);
export default __webpack_public_path__ + "static/media/spot-icon.1777dfef5eec9457426fa6f85528cec2.svg";
export { ForwardRef as ReactComponent };